import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import axios from "axios";
import { Formik, Field, Form, ErrorMessage } from "formik";

import SmsIcon from "shared/ui/svg-icons/SmsIcon";
import SvgIcon from "../../assets/SvgIcon";

import Modal from "react-modal";
import { smsValidations } from "./smsValidations";
import "./style.scss";
import MixpanelService from "shared/services/MixpanelService";

export default function SmsWidget(props) {
  const { campaignId, shareText } = props;
  const { smsForm: validations } = smsValidations;

  const [smsPopupOpen, setSmsPopupOpen] = useState(false);
  const [sentMessage, setSentMessage] = useState(false);

  const openPopup = () => {
    setSmsPopupOpen(true);
    setSentMessage(false);
    MixpanelService.trackShareClick("SMS");
  };

  const handleSubmit = (values) => {
    const smsFormData = new FormData();
    smsFormData.append("sms[phone_numbers][]", values.phoneNumber);
    smsFormData.append("sms[campaign_id]", campaignId);
    smsFormData.append("sms[name]", values.name);

    const token = $('meta[name="csrf-token"]').attr("content");
    axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
    axios
      .post("/sms", smsFormData)
      .then(() => {
        setSentMessage(true);
      })
      .catch(() => {
        console.log("error sending text");
      });
  };

  return (
    <Fragment>
      <Modal className="sms-popup" isOpen={smsPopupOpen} ariaHideApp={false}>
        <button
          data-testid="t-SmsWidg-modal-close-button"
          aria-label="Modal Close Button"
          className="modal-close-button"
          onClick={() => setSmsPopupOpen(false)}>
          <SvgIcon icon="close" size="24px" color="#666" />
        </button>
        {sentMessage && <div className="">SMS Sent</div>}
        {!sentMessage && (
          <Formik
            enableReinitialize={true}
            validationSchema={validations}
            initialValues={{
              name: "",
              phoneNumber: "",
            }}
            onSubmit={handleSubmit}>
            {({ values }) => (
              <Form data-testid="t-SmsWidg-Form-2">
                <div className="">
                  <label className="custom-field one">
                    <Field name="name" />
                    <span className="placeholder">Name</span>
                  </label>
                  <div className="input-row">
                    <ErrorMessage
                      component="div"
                      className="centered-error"
                      name="name"
                    />
                  </div>
                  <span className="title-text">
                    Enter phone number to send text message to:
                  </span>
                  <label className="custom-field one">
                    <Field name="phoneNumber" />
                    <span className="placeholder">Phone Number</span>
                  </label>
                  <div className="input-row">
                    <ErrorMessage
                      component="div"
                      className="centered-error"
                      name="phoneNumber"
                    />
                  </div>
                  <div className="input-row">
                    <span>
                      From: {values.name} -- {shareText}
                    </span>
                  </div>
                  <button
                    data-testid="t-SmsWidg-submit"
                    className="sg-button-primary button-position"
                    type="submit">
                    SUBMIT
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Modal>

      <button
        data-testid="t-SmsWidg-share-via-sms"
        className="sms-button"
        aria-label="Share via SMS"
        onClick={() => openPopup(true)}>
        <SmsIcon />
      </button>
    </Fragment>
  );
}

SmsWidget.propTypes = {
  campaignId: PropTypes.string.isRequired,
  shareText: PropTypes.string.isRequired,
};
